import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";
import BackToTop from "../components/BackToTop";
import { useSEO } from "../lib/useSEO";
import { LEGAL, SITE } from "../lib/site";

export default function MentionsLegales() {
  useSEO({
    title: "Mentions légales — K'REUSE EXTÉRIEUR",
    description:
      "Mentions légales du site K'REUSE EXTÉRIEUR — Paysagiste et lutte anti-nuisibles en Creuse.",
    canonical: "https://kreuse-exterieur.fr/mentions-legales",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Accueil", item: "https://kreuse-exterieur.fr/" },
        { "@type": "ListItem", position: 2, name: "Mentions légales", item: "https://kreuse-exterieur.fr/mentions-legales" },
      ],
    },
  });

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header />
      <main className="pt-32 pb-24 max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-sm tracking-[0.25em] uppercase text-[#1B5E20] font-medium mb-3">
          Informations légales
        </div>
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-light tracking-tight text-[#1A2E1C] mb-10">
          Mentions <span className="font-medium text-[#1B5E20]">légales</span>
        </h1>

        <div className="prose prose-lg max-w-none space-y-8 text-[#1A2E1C]">
          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Éditeur du site</h2>
            <ul className="space-y-1 text-[#1A2E1C]">
              <li><strong>Raison sociale :</strong> K'REUSE EXTÉRIEUR</li>
              <li><strong>Forme juridique :</strong> {LEGAL.status}</li>
              <li><strong>Représentant légal :</strong> {LEGAL.director}</li>
              <li><strong>Siège social :</strong> {LEGAL.address}</li>
              <li><strong>SIRET :</strong> {LEGAL.siret}</li>
              <li><strong>TVA Intracommunautaire :</strong> {LEGAL.tvaIntra}</li>
              <li><strong>Téléphone :</strong> <a href={`tel:${SITE.phoneRaw}`} className="text-[#1B5E20] hover:underline">{SITE.phone}</a></li>
              <li><strong>Email :</strong> <a href={`mailto:${SITE.email}`} className="text-[#1B5E20] hover:underline">{SITE.email}</a></li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Directeur de la publication</h2>
            <p>{LEGAL.director}, en qualité de président de la SASU K'REUSE EXTÉRIEUR.</p>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Hébergement</h2>
            <p>
              Le site <strong>kreuse-exterieur.fr</strong> est hébergé par <strong>{LEGAL.hosting}</strong>.
            </p>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Propriété intellectuelle</h2>
            <p>
              L'ensemble des contenus présents sur ce site (textes, images, logos, photographies, vidéos)
              est la propriété exclusive de K'REUSE EXTÉRIEUR ou de ses partenaires, et est protégé
              par les lois françaises et internationales relatives à la propriété intellectuelle.
              Toute reproduction, représentation, modification ou exploitation totale ou partielle est
              strictement interdite sans autorisation écrite préalable.
            </p>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Limitation de responsabilité</h2>
            <p>
              K'REUSE EXTÉRIEUR met tout en œuvre pour offrir aux utilisateurs des informations
              fiables et à jour. Cependant, des erreurs ou omissions peuvent survenir. L'utilisateur
              devra donc s'assurer de l'exactitude des informations directement auprès de l'entreprise
              et signaler toute modification du site qu'il jugerait utile.
            </p>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Litiges</h2>
            <p>
              Le présent site est régi par le droit français. En cas de litige, et après tentative de
              recherche d'une solution amiable, compétence expresse est attribuée aux tribunaux
              français.
            </p>
          </section>

          <section>
            <h2 className="font-['Outfit'] text-2xl font-semibold mb-3">Crédits</h2>
            <p>Photographies et illustrations : K'REUSE EXTÉRIEUR, Pexels, Unsplash.</p>
          </section>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
      <BackToTop />
    </div>
  );
}
